import { dragAndDropDriverFactory } from '../../utils/DragAndDrop/dragAndDropDriverFactory';
import { deprecationTestkitLog } from '../../utils/deprecationTestkitLog';

const draggableDriverFactory = ({ element, wrapper, component }) => {
  deprecationTestkitLog(
    'draggableDriverFactory legacy testkit is deprecated and will be removed in next major release. Please use draggableUniDriverFactory from Draggable.uni.driver instead.',
  );

  const dragAndDropDriver = dragAndDropDriverFactory({ element });

  return {
    wrapper,
    exists: () => !!element,
    childByHook: hook => element.querySelector(`[data-hook="${hook}"]`),
    component,

    /** fire dragstart event for the provided draggable item */
    beginDrag: ({ dataHook }) => dragAndDropDriver.beginDrag({ dataHook }),

    /** fire dragover event for the provided draggable item */
    dragOver: ({ dataHook }) => dragAndDropDriver.dragOver({ dataHook }),

    /** fire drop and dragend events for the provided draggable item */
    endDrag: draggableItemDetails =>
      dragAndDropDriver.endDrag(draggableItemDetails),
  };
};

export { draggableDriverFactory };
